import React from "react";



const PersonalInfoEn = () => {
  return (
    <p class="justify no-margin-bottom">
DYAR is a group of professionals providing high-quality, tailored services in the fields of audit, accounting, tax advisory, and management consulting for over 15 years. Our team members are agile professionals who have acquired their expertise at international consulting firms and medium-sized domestic companies. We aim to provide our clients with quality, value-added services to support their goals and offer immediate solutions to a wide range of business challenges in our fast-changing world. Our focus is on up-to-date expertise and a high level of customer centricity. We devote special attention to personal connections, as we believe this is the best way to understand and serve our clients’ needs.      </p>
  );
};

export default PersonalInfoEn;
